import * as React from 'react';
import { LoaderIcon } from '@cian/ui-kit/prev';

interface ILoaderProps {
  size?: string;
}

export const Loader = ({ size = '32px' }: ILoaderProps) => {
  return <LoaderIcon custom={{ size }} styles={{ color: '2B87DB' }} />;
};
